import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddAiChatFeedbackMutationVariables = Types.Exact<{
  input: Types.Ai_Chat_Feedback_Insert_Input;
}>;


export type AddAiChatFeedbackMutation = { __typename?: 'mutation_root', insert_ai_chat_feedback_one?: { __typename?: 'ai_chat_feedback', id: any, notes?: string | null, created_at: any, created_by_user_id: string, was_issue_resolved: boolean } | null };


export const AddAiChatFeedbackDocument = gql`
    mutation addAiChatFeedback($input: ai_chat_feedback_insert_input!) {
  insert_ai_chat_feedback_one(
    object: $input
    on_conflict: {constraint: ai_chat_feedback_pkey, update_columns: [was_issue_resolved, notes]}
  ) {
    id
    notes
    created_at
    created_by_user_id
    was_issue_resolved
  }
}
    `;
export type AddAiChatFeedbackMutationFn = Apollo.MutationFunction<AddAiChatFeedbackMutation, AddAiChatFeedbackMutationVariables>;

/**
 * __useAddAiChatFeedbackMutation__
 *
 * To run a mutation, you first call `useAddAiChatFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiChatFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiChatFeedbackMutation, { data, loading, error }] = useAddAiChatFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAiChatFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddAiChatFeedbackMutation, AddAiChatFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAiChatFeedbackMutation, AddAiChatFeedbackMutationVariables>(AddAiChatFeedbackDocument, options);
      }
export type AddAiChatFeedbackMutationHookResult = ReturnType<typeof useAddAiChatFeedbackMutation>;
export type AddAiChatFeedbackMutationResult = Apollo.MutationResult<AddAiChatFeedbackMutation>;
export type AddAiChatFeedbackMutationOptions = Apollo.BaseMutationOptions<AddAiChatFeedbackMutation, AddAiChatFeedbackMutationVariables>;